import { ChangeEvent, FormEvent } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { ButtonWithSpinner } from "@containers/common/button-with-spinner/button-with-spinner";
import { MessagingTemplateContentValidationErrors } from "@idw-types/common/validation/messaging-template/messaging-template-validation-errors";
import { MessagingTemplatePreviewContainer } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-preview-container/messaging-template-preview-container";
import { ThemingConfigurationContainer } from "@containers/common/theming-configuration-container/theming-configuration-container";
import { ThemingFormContainer } from "@containers/common/theming-form-container/theming-form-container";
import { MessagingTemplateContentFormSection } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-content-tab/messaging-template-content-form-section/messaging-template-content-form-section";
import { LabelWidthTypes } from "@enums/label-width-types";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";

type MessagingTemplateContentFormProps = {
    state: FormattedMessagingTemplate;
    requestInProgress: boolean;
    selectedLanguage: LocaleTypes;
    validationErrors: MessagingTemplateContentValidationErrors;
    setSelectedLanguage: (language: LocaleTypes) => void;
    setState: (state: FormattedMessagingTemplate) => void;
    onBackClicked: () => void;
    handleSubmit: (event: FormEvent) => void;
};

export const MessagingTemplateContentForm = (props: MessagingTemplateContentFormProps) => {
    const {
        state,
        requestInProgress,
        selectedLanguage,
        validationErrors,
        setState,
        onBackClicked,
        handleSubmit
    } = props;

    const handleUpdateTemplate = (event: ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            template: event.target.value
        });
    };

    const resource = resources.modals.addMessagingTemplate;

    return (
        <Form onSubmit={handleSubmit}>
            <Modal.Header id={"add-messaging-template-title"} closeButton>
                <Modal.Title>{resource.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ThemingConfigurationContainer>
                    <ThemingFormContainer>
                        <MessagingTemplateContentFormSection
                            isDisabled={false}
                            labelWidth={LabelWidthTypes.MEDIUM}
                            state={state}
                            validationErrors={validationErrors}
                            handleUpdateTemplate={handleUpdateTemplate}
                        />
                    </ThemingFormContainer>
                    <MessagingTemplatePreviewContainer
                        state={state}
                        selectedLanguage={selectedLanguage}
                    />
                </ThemingConfigurationContainer>
            </Modal.Body>
            <Modal.Footer>
                <Button id="add-messaging-template-back-button" variant="secondary" onClick={onBackClicked}>{resources.common.buttons.back.label}</Button>
                <ButtonWithSpinner
                    id="add-messaging-template-next-to-variables-button"
                    disabled={requestInProgress || validationErrors.count > 0}
                    hideSpinner={validationErrors.count > 0}
                    variant="primary"
                    type={ButtonTypes.SUBMIT}
                    label={resource.buttons.nextToVariables.label}
                />
            </Modal.Footer>
        </Form>
    );
};